// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/broadcast-messages/app/css/app.css
// module id = 797
// module chunks = 0